export const environment = {
    production: true,
    api_uri: '/bsiAF/api/',
    id_token: 'id_token',
    x_auth_token_header: 'x-auth-token',
    auth_header: 'Authorization',
    user_object: 'user_object',
    user_vendor_object :'user_vendor_object',
    user_navigations: 'user_navigations',
	verify_token_header: 'verify-token'
};
